import { PaymentType } from '@/features/graphql/generated/graphql'

export enum FormKeys {
    ActualAmounts = 'actualAmounts',
}

export const paymentTypeFieldNames = {
    [PaymentType.CardOnsite]: `${FormKeys.ActualAmounts}.${PaymentType.CardOnsite}`,
    [PaymentType.Cash]: `${FormKeys.ActualAmounts}.${PaymentType.Cash}`,
    [PaymentType.Invoice]: `${FormKeys.ActualAmounts}.${PaymentType.Invoice}`,
    [PaymentType.MealVoucher]: `${FormKeys.ActualAmounts}.${PaymentType.MealVoucher}`,
    [PaymentType.MealVoucherCard]: `${FormKeys.ActualAmounts}.${PaymentType.MealVoucherCard}`,
    [PaymentType.Online]: `${FormKeys.ActualAmounts}.${PaymentType.Online}`,
} as const satisfies Record<PaymentType, string>

export type ActualAmountFieldName = (typeof paymentTypeFieldNames)[PaymentType]
